import { combineReducers } from 'redux';
import clientsReducer from './clients';
import sessionsReducer from './sessions';

const uiReducer = combineReducers({
  clients: clientsReducer,
  sessions: sessionsReducer,
});

export default uiReducer;
